<template lang="html">

<div class="floorList">

  <el-table
        :data="floorArr"
        border
        style="width: 100%">
        <el-table-column fixed="left" align="center" width="60" label="序号">
            <template slot-scope="scope">
                 {{ scope.$index + (params.no - 1)*params.size + 1 }}
            </template>
        </el-table-column>
        <el-table-column prop="controlFloor" align="center" label="空置楼层" />
        <el-table-column prop="vacantArea" align="center" width="150" label="空置面积(平方米)" />
        <el-table-column prop="decoration" width="150" align="center" label="装修情况" />
        <el-table-column prop="decorationInstructions" width="180" align="center" label="装修说明" />
        <el-table-column prop="actualUtilization" width="180" align="center" label="实际利用率(%)" />
        <el-table-column prop="floorHeight" width="120" align="center" label="层高(米)"/>
        <el-table-column prop="turnTowards" width="120" align="center" label="朝向" />
        <el-table-column prop="paymentMethod" width="120" align="center" label="交付方式" />
        <el-table-column width="180" align="center" label="报价(元/天/平方米)">
            <template slot-scope="scope">
               {{scope.row | priceTrans(1)}}
            </template>
        </el-table-column>
         <el-table-column prop="propertyCosts" width="180" align="center" label="物业费用(元/天/平方米)" />
        <el-table-column width="120" align="center" label="是否出售">
           <template slot-scope="scope">
              {{scope.row.isSell | strTrans}}
           </template>
        </el-table-column>
        <el-table-column width="180" align="center" label="出售说明" >
            <template slot-scope="scope">
               {{scope.row | priceTrans(3)}}
            </template>
        </el-table-column>
        <el-table-column prop="price" width="180" align="center" label="最高售价">
            <template slot-scope="scope">
               {{scope.row | priceTrans(2)}}
            </template>
        </el-table-column>
   </el-table>

   <div v-if="allPages>1" class="table-footer">

      <el-pagination
        @current-change="pageChange"
        :current-page="params.no"
        :page-size="params.size"
        layout="total, prev, pager, next, jumper"
        :total="params.allEls">
      </el-pagination>

  </div>

</div>

</template>

<script>
import { getFloors } from '@/api/industryInfos';
export default {
    filters:{
       strTrans(e){
           let arr = ['出售','出租']
           return arr[e-1];
       },
       priceTrans(row,type){
           if(type == 1){
                if(row.isSell==2){
                   return row.price;
                }else{
                   return '-';
                }
           }else if(type == 2){
                if(row.isSell==1){
                  return row.price + row.sellingPriceUtil;
                }else{
                  return '-';
                }
           }else if(type == 3){
                if(row.isSell == 1){
                   return row.sellingInstructions;
                }else{
                   return '-';
                }
           }
       }
    },
    data(){
       return{
           floorArr:[],
           allPages:0,
           loading:false,
           params:{
               industrialSpaceId:'',
               no:1,
               size:5,
               allEls:0
           }
       }
    },
    methods:{
      getList(){
        getFloors(this.params).then(res => {
           this.floorArr = res.industrialSpaceFloorWhereList;
           this.params.allEls = res.totalElements;
           this.allPages = res.totalPages;
           this.$emit('floorC',res.totalElements);
        })
      },
      pageChange(e){
        this.params.no = e;
        this.getList();
      }
    },
    created(){
      let querys = this.$route.query;
      this.params.industrialSpaceId = querys.id;
      this.getList();
    }
}
</script>

<style lang="scss" scoped>

.floorList{
  .table-footer{
      margin-top: 20px;
      text-align: right;
  }
}


</style>



// WEBPACK FOOTER //
// floorList.vue?ad28b224